import { Component, type ReactNode } from 'react';

/**
 * Catches a scene that cannot start, and says so.
 *
 * Probing for WebGL with a throwaway context was worse than useless: the probe
 * itself consumed a context, and a single flaky result got cached for the life
 * of the page, stranding capable browsers on the still. Now the canvas simply
 * tries, and this boundary catches the failure that matters.
 */
export class SceneBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error): void {
    console.info(
      `[black-bear] perimeter canvas fell back to the drawn plan still: ${error.message}`,
    );
  }

  render(): ReactNode {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}

interface Props {
  children: ReactNode;
  fallback: ReactNode;
}

interface State {
  failed: boolean;
}
